import DatabaseModel from './DatabaseModel.js';

var UserNotificacion = Object.create(DatabaseModel);

UserNotificacion.model = 'notificaciones/users';

export default UserNotificacion;